// blog js

document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('blog-search-input');
  const resultsContainer = document.getElementById('search-results-container');

  if (!searchInput || !resultsContainer) {
    return; 
  }

  let articles = [];

  try {
    const jsonData = document.getElementById('blog-articles-json')?.textContent;
    if (jsonData) {
      articles = JSON.parse(jsonData);
    }
  } catch (e) {
  }

  searchInput.addEventListener('input', function () {
    const query = this.value.trim().toLowerCase();

    if (query.length > 0) {
      const filtered = articles.filter(article =>
   article.title.toLowerCase().includes(query)
   );
      displayResults(filtered);
    } else {
      resultsContainer.style.display = 'none';
      resultsContainer.innerHTML = '';
    }
  });

  function displayResults(results) {
    resultsContainer.innerHTML = '';

    if (results.length > 0) {
      results.forEach(result => {
        const div = document.createElement('div');
        div.innerHTML = `<a href="${result.url}">${result.title}</a>`;
        resultsContainer.appendChild(div);
      });
      resultsContainer.style.display = 'block';
    } else {
      resultsContainer.style.display = 'none';
    }
  }

  document.addEventListener('click', function (event) {
    if (!searchInput.contains(event.target) && !resultsContainer.contains(event.target)) {
      resultsContainer.style.display = 'none';
    }
  });
});


// Apply movement only while visitors interact with a supported card.
if (matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) {
  document.querySelectorAll('.main-category-product .cate-card').forEach(card => {
    const image = card.querySelector('.cate-image');
    if (!image) return;
    image.style.transition = 'transform .2s ease-out';
    card.addEventListener('mousemove', event => {
      const rect = card.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - .5;
      const y = (event.clientY - rect.top) / rect.height - .5;
      image.style.transform = `translate(${x * 24}px, ${y * 16}px) rotate(${x * 8}deg)`;
    });
    card.addEventListener('mouseleave', () => { image.style.transform = ''; });
  });
  document.querySelectorAll('.ui-test-collection-list .resource-list__item').forEach(item => {
    const wrapper = item.querySelector('.category-icon-wrapper');
    const icon = item.querySelector('.category-icon');
    if (!wrapper || !icon) return;
    item.addEventListener('mousemove', event => {
      const rect = item.getBoundingClientRect();
      wrapper.style.opacity = '1';
      icon.style.left = `${(event.clientX - rect.left) / rect.width * 100}%`;
      icon.style.top = `${(event.clientY - rect.top) / rect.height * 100}%`;
      icon.style.transform = 'translate(-50%, -50%)';
    });
    item.addEventListener('mouseleave', () => { wrapper.style.opacity = '0'; });
  });
}

// compare code start

// Compare functionality
(function() {
  // Guard against this script executing more than once on the same page
  // (e.g. if the asset is accidentally included twice) — without this,
  // a single click fires two listeners: one adds the product, the second
  // immediately sees it in the list and removes it again, which is why
  // the button appeared to only ever "remove" products.
  if (window.__compareInitialized) return;
  window.__compareInitialized = true;

  const COMPARE_KEY = 'compareProducts';
  const MAX_COMPARE = 3;

  function getCompareProducts() {
    return JSON.parse(localStorage.getItem(COMPARE_KEY) || '[]');
  }

  function saveCompareProducts(products) {
    localStorage.setItem(COMPARE_KEY, JSON.stringify(products));
  }

  function updateCompareButtons() {
    const products = getCompareProducts();
    document.querySelectorAll('.compare_button').forEach(btn => {
      const title = btn.dataset.title;
      const isAdded = products.some(p => p.title === title);
      btn.classList.toggle('active', isAdded);
      btn.title = isAdded ? 'Remove from Compare' : 'Compare';
    });
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.compare_button');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    let products = getCompareProducts();
    const productData = {
      title: btn.dataset.title || '',
      image: btn.dataset.image || '',
      description: btn.dataset.description || '',
      type: btn.dataset.type || '',
      vendor: btn.dataset.vendor || '',
      price: btn.dataset.price || '',
      availability: btn.dataset.availability || '',
      url: btn.dataset.url || ''
    };

    const existingIndex = products.findIndex(p => p.title === productData.title);

    if (existingIndex > -1) {
      // Remove if already added
      products.splice(existingIndex, 1);
      saveCompareProducts(products);
      btn.classList.remove('active');
      showCompareNotification('Product removed from compare', false);
      return;
    }

    if (products.length >= MAX_COMPARE) {
      showCompareNotification('Maximum 3 products can be compared!', true);
      return;
    }

    products.push(productData);
    saveCompareProducts(products);
    btn.classList.add('active');

    if (products.length >= 2) {
      showCompareNotification(
        products.length + ' products added. <a href="/pages/compare" style="color:#fff;text-decoration:underline;">Compare Now</a>',
        false
      );
    } else {
      showCompareNotification('Product added! Select one more to compare.', false);
    }
  });

  function showCompareNotification(message, isError) {
    let toast = document.getElementById('compare-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'compare-toast';
      toast.style.cssText = `
        position: fixed;
        bottom: 80px;
        left: 50%;
        transform: translateX(-50%);
        background: ${isError ? '#e53e3e' : '#276749'};
        color: white;
        padding: 12px 24px;
        border-radius: 8px;
        font-size: 14px;
        z-index: 99999;
        box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        transition: opacity 0.3s ease;
        text-align: center;
        min-width: 260px;
      `;
      document.body.appendChild(toast);
    }
    toast.style.background = isError ? '#e53e3e' : '#276749';
    toast.innerHTML = message;
    toast.style.opacity = '1';
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => {
      toast.style.opacity = '0';
    }, 3000);
  }

  document.addEventListener('DOMContentLoaded', updateCompareButtons);
})();

// compare code end

// collection add to cart button code
(function () {
        var formId = '{{ product_form_id }}';
        var form = document.getElementById(formId);
        if (!form) return;

        // If typical theme product form handler exists, don't override (best-effort detection).
        // (Different themes use different handlers — this check is conservative.)
        if (window.ProductForm || (window.theme && window.theme.ProductForm)) {
          return;
        }

        form.addEventListener('submit', function (e) {
          e.preventDefault();

          var formData = new FormData(form);
          var variantId = formData.get('id');
          var quantity = parseInt(formData.get('quantity') || '1', 10);

          if (!variantId) {
            console.warn('QuickAdd: no variant id present — cannot add to cart.');
            form.submit(); // fallback to regular submit
            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity }),
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Add to cart failed');
              return res.json();
            })
            .then(function () {
              // fetch cart and dispatch an event so any drawer can update
              return fetch('/cart.js');
            })
            .then(function (res) {
              return res.json();
            })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
              // Try to open cart drawer if your theme has a toggle element
              var openBtn = document.querySelector(
                '[data-open-cart-drawer], [data-cart-toggle], .cart-toggle, .cart-drawer__open'
              );
              if (openBtn) {
                // Some themes expect a click; others listen to custom events.
                openBtn.click();
              }
            })
            .catch(function (err) {
              console.error('QuickAdd add-to-cart error:', err);
              // Last resort: submit normally to let server handle
              form.submit();
            });
        });
      })();

// size chart popup
document.addEventListener("DOMContentLoaded", function() {
  const modal = document.querySelector(".sizeModal");
  const openBtn = document.querySelector(".openSizeChart");
  const closeBtn = modal ? modal.querySelector(".custom-close") : null;

  if (!modal || !openBtn || !closeBtn) return; // stop if elements missing

  openBtn.addEventListener("click", function(e) {
    e.preventDefault();
    modal.style.display = "block";
  });

  closeBtn.addEventListener("click", function() {
    modal.style.display = "none";
  });

  window.addEventListener("click", function(e) {
    if (e.target === modal) {
      modal.style.display = "none";
    }
  });
});


// notify me button js

document.addEventListener("DOMContentLoaded", function () {
  const notifyButton = document.querySelector(".notify-me-button");
  const notifyOverlay = document.querySelector(".notify-popup-overlay");
  const closeBtn = document.querySelector(".close-popup");

  if (notifyButton && notifyOverlay) {
    notifyButton.addEventListener("click", function (e) {
      e.preventDefault();
      notifyOverlay.style.display = "flex"; // show modal
    });
  }

  if (closeBtn && notifyOverlay) {
    closeBtn.addEventListener("click", function () {
      notifyOverlay.style.display = "none"; // hide modal
    });
  }

  // Close if click outside the modal content
  if (notifyOverlay) {
    notifyOverlay.addEventListener("click", function (e) {
      if (e.target === notifyOverlay) {
        notifyOverlay.style.display = "none";
      }
    });
  }
});


// color swatch js start

document.addEventListener("click", function (e) {
  if (e.target.matches(".color-swatch-btn")) {
    const swatch = e.target;
    const imageUrl = swatch.dataset.image;
    const productCard = swatch.closest(".product-card");
    if (!productCard) return;
    const mainImg = productCard.querySelector(".product-media-container img");

    if (mainImg && imageUrl) {
      mainImg.src = imageUrl;
      mainImg.srcset = imageUrl;
    }

    // Toggle active class for highlight
    productCard.querySelectorAll(".color-swatch-btn").forEach(btn => btn.classList.remove("active"));
    swatch.classList.add("active");
  }
});

// add to cart button spinner js

(function() {
  // Time to fallback reset if no AJAX hook used (ms)
  const RESET_TIMEOUT = 2500;

  function showSpinnerForButton(button) {
    if (!button) return;
    const spinner = button.querySelector('.cart-spinner');
    const preorderText = button.querySelector('.preorder-text');
    const addToCartText = button.querySelector('.add-to-cart-text__content');
    if (!spinner) return;

    // Hide texts if present
    if (preorderText) preorderText.style.display = 'none';
    if (addToCartText) addToCartText.style.display = 'none';

    spinner.hidden = false;
    button.classList.add('is-loading');

    // Return a function to reset
    return function resetSpinner() {
      spinner.hidden = true;
      if (preorderText) preorderText.style.display = '';
      if (addToCartText) addToCartText.style.display = '';
      button.classList.remove('is-loading');
    };
  }

  // Global submit handler — use capture so we catch events early for dynamic forms
  document.addEventListener('submit', function(event) {
    try {
      const form = event.target;
      // Only care about product add-to-cart forms (heuristic)
      // Adjust selector if your forms don't use data-type or action
      const isAddToCartForm = form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');

      if (!isAddToCartForm) return;

      // Get the actual button that submitted the form (supported in modern browsers)
      let button = event.submitter || form.querySelector('.add-cart-button, button[type="submit"], input[type="submit"]');

      // If no button found, search broader (some themes place button outside form)
      if (!button) {
        // Try to find nearest .add-cart-button by id reference or within document
        button = document.querySelector('.add-cart-button');
      }
      if (!button) return;

      // Show spinner & get reset function
      const reset = showSpinnerForButton(button);

      // If the site uses non-AJAX (full page reload), spinner will show during navigation.
      // If it's AJAX, you should call reset() when AJAX completes. We'll also set a safe fallback.
      if (typeof window.__shopify_addToCart_hook === 'function') {
        // If user provided a global hook, assume it will call reset when done.
        try {
          window.__shopify_addToCart_hook(form, button, reset);
        } catch (e) {
          // ignore hook errors
        }
      }

      // Fallback: reset after a timeout if not handled elsewhere
      setTimeout(function() {
        try { reset && reset(); } catch (e) { /* noop */ }
      }, RESET_TIMEOUT);

      // Let the submit proceed normally (don't preventDefault).
    } catch (err) {
      // Don't let errors stop the form submission
      console.error('Spinner submit handler error:', err);
    }
  }, true /* capture */);

  // Optional: expose a global function to reset spinner from your AJAX success callback:
  window.__reset_add_to_cart_spinner = function(button) {
    if (!button) return;
    const spinner = button.querySelector('.cart-spinner');
    const preorderText = button.querySelector('.preorder-text');
    const addToCartText = button.querySelector('.add-to-cart-text__content');
    if (spinner) spinner.hidden = true;
    if (preorderText) preorderText.style.display = '';
    if (addToCartText) addToCartText.style.display = '';
    button.classList.remove('is-loading');
  };
})();

// Wishlist functionality
(function () {
  const WISHLIST_KEY = 'wishlist_items';

  function getWishlist() {
    try { const items = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); return Array.isArray(items) ? items : []; } catch { return []; }
  }

  function saveWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
  }

  function addToWishlist(productId, productTitle, productImage, productUrl) {
    const items = getWishlist();
    if (!items.find(i => i.id === productId)) {
      items.push({ id: productId, title: productTitle, image: productImage, url: productUrl });
      saveWishlist(items);
    }
    updateWishlistButtons();
    renderWishlistPage();
  }

  function removeFromWishlist(productId) {
    let items = getWishlist().filter(i => i.id !== productId);
    saveWishlist(items);
    updateWishlistButtons();
    renderWishlistPage();
  }

  function updateWishlistButtons() {
    const items = getWishlist();
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const id = btn.dataset.productId;
      const isAdded = items.find(i => i.id === id);
      btn.classList.toggle('wishlist-active', !!isAdded);
      btn.title = isAdded ? 'Remove from Wishlist' : 'Add to Wishlist';
    });
  }

  function renderWishlistPage() {
    const container = document.querySelector('.js-wishlistBlock');
    if (!container) return;
    const items = getWishlist();
    if (items.length === 0) {
      container.innerHTML = '<p class="wishlist-empty">Your wishlist is empty.</p>';
      return;
    }
    container.innerHTML = items.map(item => `
      <div class="wishlist-item" data-id="${item.id}">
        <a href="${item.url}">
          <img src="${item.image}" alt="${item.title}" style="width:100px;">
          <p>${item.title}</p>
        </a>
        <button class="wishlist-remove-btn" data-remove-id="${item.id}">Remove</button>
      </div>
    `).join('');

    container.querySelectorAll('.wishlist-remove-btn').forEach(btn => {
      btn.addEventListener('click', () => removeFromWishlist(btn.dataset.removeId));
    });
  }
})();
